import { ACCESS_PENDING, AUTH } from 'constants/path';

export const PATHS_PREVENTING_ACCESS_PENDING_REDIRECT = [ACCESS_PENDING, AUTH];
